import {
  CREATE_IP_WHITELIST,
  CREATE_IP_WHITELIST_IS_ERROR,
  CREATE_IP_WHITELIST_IS_PENDING,
  DELETE_IP_WHITELIST,
  DELETE_IP_WHITELIST_IS_ERROR,
  DELETE_IP_WHITELIST_IS_PENDING,
  FETCH_IP_WHITELIST,
  FETCH_IP_WHITELIST_IS_ERROR,
  FETCH_IP_WHITELIST_IS_PENDING,
  SORT,
  SWITCH_STATUS_IP_WHITELIST,
  SWITCH_STATUS_IP_WHITELIST_IS_ERROR,
  SWITCH_STATUS_IP_WHITELIST_IS_PENDING,
  UPDATE_IP_WHITELIST,
  UPDATE_IP_WHITELIST_IS_ERROR,
  UPDATE_IP_WHITELIST_IS_PENDING,
} from 'services/Account/IpWhitelist/types';
import { SortDirection } from 'types/common/sorting';
import { addNew, sort } from 'utils/functions';

const INITIAL_STATE = {
  ipWhitelist: [],
  fetchIsPending: false,
  fetchIsCompleted: false,
  fetchIsError: null,
  sortBy: 'description',
  sortDirection: 'DESC' as SortDirection,
  params: {},
};

const CUD_PROPERTIES = {
  createIsPending: false,
  createIsCompleted: false,
  createIsError: null,
  updateIsPending: false,
  updateIsCompleted: false,
  updateIsError: null,
  deleteIsPending: false,
  deleteIsCompleted: false,
  deleteIsError: null,
  switchStatusIsPending: false,
  switchStatusIsCompleted: false,
  switchStatusIsError: null,
};

const ipWhitelistReducer = (
  state = {
    ...INITIAL_STATE,
    ...CUD_PROPERTIES,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case FETCH_IP_WHITELIST:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        ipWhitelist: sort(action.data, {
          sortBy: state.sortBy,
          sortDirection: state.sortDirection,
          sortSearchValue: (state.params as $TSFixMe).sortSearchValue || (state.params as $TSFixMe).value || null,
        }),
        fetchIsPending: false,
        fetchIsCompleted: true,
        fetchIsError: null,
      };
    case FETCH_IP_WHITELIST_IS_PENDING:
      return {
        ...state,
        fetchIsPending: true,
        fetchIsCompleted: false,
        fetchIsError: null,
      };
    case FETCH_IP_WHITELIST_IS_ERROR:
      return {
        ...state,
        fetchIsPending: false,
        fetchIsCompleted: true,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchIsError: action.error,
      };
    case CREATE_IP_WHITELIST:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        ipWhitelist: addNew(action.data, state.ipWhitelist),
        createIsPending: false,
        createIsCompleted: true,
        createIsError: null,
      };
    case CREATE_IP_WHITELIST_IS_PENDING:
      return {
        ...state,
        createIsPending: true,
        createIsCompleted: false,
        createIsError: null,
      };
    case CREATE_IP_WHITELIST_IS_ERROR:
      return {
        ...state,
        createIsPending: false,
        createIsCompleted: true,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        createIsError: action.error,
      };

    case UPDATE_IP_WHITELIST: {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const ipIndex = state.ipWhitelist.findIndex((x) => (x as $TSFixMe).id === action.data.id);

      return {
        ...state,
        ipWhitelist: state.ipWhitelist.map((ip, index) => {
          if (index !== ipIndex) {
            return ip;
          }

          return {
            // @ts-expect-error ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
            ...ip,

            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            ...action.data,
          };
        }),
        updateIsPending: false,
        updateIsCompleted: true,
        updateIsError: null,
      };
    }

    case UPDATE_IP_WHITELIST_IS_PENDING:
      return {
        ...state,
        updateIsPending: true,
        updateIsCompleted: false,
        updateIsError: null,
      };
    case UPDATE_IP_WHITELIST_IS_ERROR:
      return {
        ...state,
        updateIsPending: false,
        updateIsCompleted: true,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        updateIsError: action.error,
      };

    case DELETE_IP_WHITELIST: {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const ipIndex = state.ipWhitelist.findIndex((x) => (x as $TSFixMe).id === action.data.id);

      return {
        ...state,
        ipWhitelist: [...state.ipWhitelist.slice(0, ipIndex), ...state.ipWhitelist.slice(ipIndex + 1)],
        deleteIsPending: false,
        deleteIsCompleted: true,
        deleteIsError: null,
      };
    }

    case DELETE_IP_WHITELIST_IS_PENDING:
      return {
        ...state,
        deleteIsPending: true,
        deleteIsCompleted: false,
        deleteIsError: null,
      };
    case DELETE_IP_WHITELIST_IS_ERROR:
      return {
        ...state,
        deleteIsPending: false,
        deleteIsCompleted: true,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        deleteIsError: action.error,
      };
    case SWITCH_STATUS_IP_WHITELIST:
      return {
        ...state,
        switchStatusIsPending: false,
        switchStatusIsCompleted: true,
        switchStatusIsError: null,
      };
    case SWITCH_STATUS_IP_WHITELIST_IS_PENDING:
      return {
        ...state,
        switchStatusIsPending: true,
        switchStatusIsCompleted: false,
        switchStatusIsError: null,
      };
    case SWITCH_STATUS_IP_WHITELIST_IS_ERROR:
      return {
        ...state,
        switchStatusIsPending: false,
        switchStatusIsCompleted: true,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        switchStatusIsError: action.error,
      };
    case SORT:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        params: action.params,
        ipWhitelist: sort(state.ipWhitelist, {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortSearchValue: action.params.sortSearchValue || action.params.value,
        }),
      };
    default:
      return state;
  }
};

export default ipWhitelistReducer;
